import {
  PluginOnsiteInjectionSchema_2024_05_05,
  PluginOnsiteInjectionType_2024_05_05,
} from "./2024-05-05";

export const PluginOnsiteInjectionSchema =
  PluginOnsiteInjectionSchema_2024_05_05;
export type PluginOnsiteInjectionType = PluginOnsiteInjectionType_2024_05_05;

export type { PluginOnsiteInjectionType_2024_05_05 };
